/**
 * @generated SignedSource<<e812bfc8e2682268e40441733e158ee3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type QuoteAddOn = "ACCESSORIES" | "SEVEN_DAY_PACKAGE" | "THREE_DAY_PACKAGE" | "%future added value";
export type QuoteSource = "AIRTABLE_BACKFILL" | "BOOKING_CALENDAR" | "CHATBOT" | "MANUAL" | "META_DM" | "META_LEAD" | "PARTNER_API" | "PATIENT_APP" | "QUOTE_FUNNEL" | "WEBSITE_FORM" | "%future added value";
export type QuoteInput = {
  acceptedHipaa?: boolean | null;
  activeABTests?: ReadonlyArray<ABTestVariantInput> | null;
  addOns?: ReadonlyArray<QuoteAddOn> | null;
  additionalFormFields?: any | null;
  age?: string | null;
  approverComments?: string | null;
  budget?: string | null;
  cherryFinancingFile?: FileInput | null;
  coordinatorComments?: string | null;
  coreStatus?: string | null;
  deviceTimezone?: string | null;
  draftQuoteId?: string | null;
  email: string;
  fileList?: ReadonlyArray<FileInput> | null;
  gclid?: string | null;
  hasMedicalConditions?: boolean | null;
  heightFt?: string | null;
  heightIn?: string | null;
  language?: string | null;
  lastComment?: string | null;
  lastName?: string | null;
  leadOrigin?: string | null;
  leadOriginFirst?: string | null;
  leadOriginHistory?: any | null;
  leadOriginLast?: string | null;
  locationPreference?: string | null;
  lost50pounds?: boolean | null;
  maxQuoted?: number | null;
  medicalConditions?: ReadonlyArray<string> | null;
  minQuoted?: number | null;
  name: string;
  optInText?: boolean | null;
  otherMedicalConditionDescription?: string | null;
  partnerId?: string | null;
  patientLocation?: PatientLocationInput | null;
  patientNotes?: string | null;
  patientReadiness?: string | null;
  phone: string;
  preferredMethod?: string | null;
  priorCosmeticSurgery?: boolean | null;
  priorCosmeticSurgeryDescription?: string | null;
  procedureDescription?: string | null;
  procedureOfInterest?: string | null;
  recaptchaToken?: string | null;
  selectedLocation?: string | null;
  selectedProcedureTypes?: ReadonlyArray<string> | null;
  selectedProceduresV2?: ReadonlyArray<string> | null;
  selectedSurgeon?: string | null;
  smoker?: boolean | null;
  source?: QuoteSource | null;
  staffComments?: string | null;
  status?: string | null;
  surgeonRequestComments?: string | null;
  surgeryDateRange?: string | null;
  touches?: ReadonlyArray<TouchInput> | null;
  trackingIds?: any | null;
  version?: string | null;
  weight?: string | null;
  willingToTravel?: string | null;
  zipCode: string;
};
export type PatientLocationInput = {
  city?: string | null;
  country?: string | null;
  raw?: string | null;
  state?: string | null;
};
export type FileInput = {
  directUrl?: string | null;
  name?: string | null;
  response: FileResponseInput;
  type?: string | null;
  url?: string | null;
};
export type FileResponseInput = {
  url: string;
};
export type TouchInput = {
  formId?: string | null;
  landingPath: string;
  landingQuery?: any | null;
  referrer?: string | null;
  resolvedLeadOrigin: string;
  surface: string;
  trackingIds?: any | null;
  ts: string;
};
export type ABTestVariantInput = {
  testId: string;
  testName?: string | null;
  variant: string;
  weight?: number | null;
};
export type QuoteProviderMutation$variables = {
  input: QuoteInput;
};
export type QuoteProviderMutation$data = {
  readonly addQuote: {
    readonly id: string;
    readonly patient: {
      readonly id: string;
    } | null;
  };
};
export type QuoteProviderMutation = {
  response: QuoteProviderMutation$data;
  variables: QuoteProviderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Quote",
    "kind": "LinkedField",
    "name": "addQuote",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Patient",
        "kind": "LinkedField",
        "name": "patient",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QuoteProviderMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QuoteProviderMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9e3369371927487d1875a47faa4585d9",
    "id": null,
    "metadata": {},
    "name": "QuoteProviderMutation",
    "operationKind": "mutation",
    "text": "mutation QuoteProviderMutation(\n  $input: QuoteInput!\n) {\n  addQuote(input: $input) {\n    id\n    patient {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "06eaba41174dca78be2c6adf9da0c015";

export default node;
